import { AlertColor, SvgIconProps } from '@mui/material';

export interface SnackbarNotificationData {
  message: string;
  severity: AlertColor;
}

export interface SelectOption {
  label: string;
  value: string;
  disabled?: boolean;
}

export interface MenuOption extends SelectOption {
  Icon?: (props: SvgIconProps) => JSX.Element;
  image?: string;
  caption?: string;
}

export type MenuOptions = MenuOption[];

export type SelectOptions = SelectOption[];

export type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>;
    }
  : T;

export enum AttributionModelEnum {
  net = 'Discount Code',
  dd = 'Data Driven',
  mmm = 'Simplified MMM',
}

export type AttributionPrefix<M extends AttributionModelEnum> =
  M extends AttributionModelEnum.dd
    ? 'dd_'
    : M extends AttributionModelEnum.mmm
    ? 'mmm_'
    : '';

export type AttributionField<
  T,
  M extends AttributionModelEnum,
  F extends string,
> = `${AttributionPrefix<M>}${F}` & keyof T;
